export default __webpack_public_path__ + "static/media/flame_line_top_bg.d6c973f7.svg";